<div [class.overlay]="overlay">
  <ng-content></ng-content>
</div>